import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { setTerritoryEnabled } from "../store/action-creators";

export const useResetTerritory = (): (() => void) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(setTerritoryEnabled(false));
    }, [dispatch]);
};
